// extracted by mini-css-extract-plugin
export default {"input":"phone-input_input__l6e-N","input_error":"phone-input_input_error__FbHxo"};